import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'loading-indicator',
    templateUrl: 'loading-indicator.component.html',
    styleUrls: ['loading-indicator.component.less'],
    imports: [NgClass]
})
export class LoadingIndicatorComponent {
    readonly isEmbedded = input<boolean>(false);
    readonly isPermanent = input<boolean>(false);
    readonly isSmall = input<boolean>(false);

    private _isOpen: boolean = false;
    get isOpen() {
        return this._isOpen;
    }

    show(): void {
        this._isOpen = true;
    }

    hide(): void {
        this._isOpen = false;
    }
}
